import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useState } from 'react';
import { useMaestroContext } from '../context/MaestroContext';
import maestroService from '../maestroService';
import { dispararAcaoSimulada } from '../utils/acaoSimulada';

const WizardReaberturaCiclo: React.FC<{ aberto: boolean; onFechar: () => void }> = ({ aberto, onFechar }) => {
  const { cicloAtivo, recarregar } = useMaestroContext();
  const [motivo, setMotivo] = useState('');
  const [enviando, setEnviando] = useState(false);

  const confirmar = () => {
    if (!motivo.trim()) return;
    setEnviando(true);
    maestroService.reabrirCiclo(cicloAtivo.id, motivo.trim())
      .then(() => { recarregar(); onFechar(); setMotivo(''); })
      .catch((e: any) => dispararAcaoSimulada(e?.response?.data?.message ?? 'Não foi possível reabrir o ciclo.'))
      .finally(() => setEnviando(false));
  };

  return (
    <Dialog open={aberto} onClose={onFechar} maxWidth='sm' fullWidth PaperProps={{ className: 'mc-dialog' }}>
      <DialogTitle>Reabertura de Ciclo</DialogTitle>
      <DialogContent>
        <p className='mc-texto-neutro' style={{ marginTop: 0 }}>
          Reabrir um ciclo encerrado volta as atividades para edição e registra um evento de reabertura auditável, vinculado à sua justificativa.
        </p>
        <label className='mc-campo'>Motivo da reabertura
          <textarea rows={3} placeholder='Por que este ciclo precisa ser reaberto...' value={motivo} onChange={e => setMotivo(e.target.value)} />
        </label>

        <div className='mc-wizard-acoes'>
          <button type='button' className='mc-btn mc-btn--secondary' onClick={onFechar}>Cancelar</button>
          <button type='button' className='mc-btn mc-btn--primary' disabled={enviando || !motivo.trim()} onClick={confirmar}>
            {enviando ? 'Reabrindo...' : 'Reabrir ciclo'}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WizardReaberturaCiclo;
